import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { AuthorizationApplicationEvent, IdamRegisterApplicationEvent } from '~shared/modules/application-event/models';
import {
  ApplicationAuthorizationActionType,
  ApplicationAuthorizationActionType as AuthType,
} from '~shared/modules/application-event/constants';
import { Injectable } from '@angular/core';
import { REG_EXP_EMAIL_PATTERN } from '~shared/validators/pattern-validators';

@Injectable({
  providedIn: 'root',
})
export class ValidateEmailGaTrackingService {
  constructor(
    private featureFlagSrv: ActiveFeaturesConfigcatService,
    private applicationEventService: ApplicationEventService
  ) {}

  gaTrackingValidateEmailButtonClickedEvent(authType: AuthType, message: string, format?: boolean) {
    this.applicationEventService.publish(
      new AuthorizationApplicationEvent(authType, format ? this.formatLabel(message) : message)
    );
  }

  gaTrackingInvalidEmailCheckEvent() {
    this.applicationEventService.publish(
      new AuthorizationApplicationEvent(ApplicationAuthorizationActionType.SignupError, 'Email not valid'),
      true
    );
  }

  formatLabel(error: string) {
    const finalError = error.replace(REG_EXP_EMAIL_PATTERN, '"*****"');
    return `{ ${finalError}}`;
  }
}
